// extracted by mini-css-extract-plugin
export default {"finalStepWrapper":"FinalStep_finalStepWrapper__Un3Xa","text":"FinalStep_text__qvaCH","checkedIcon":"FinalStep_checkedIcon__hghuC"};